import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

export const OFFER_TAGS_DETAIL_FORM = "offer-tags/OFFER_TAGS_DETAIL_FORM";
export const offerTagsDetailFormTypes = createFormActionTypes(OFFER_TAGS_DETAIL_FORM);
export const offerTagsDetailFormActions = createFormActions(offerTagsDetailFormTypes);
